module.exports = __webpack_public_path__ + "static/mga_logo-51877f125a26332addbb88a8b953e648.png";